export default __webpack_public_path__ + "static/media/six_month@3x.f98717c8.png";